import OTP_REMOVE from'@graphql/mutations/OtpRemove.graphql';import{Cookies}from'react-cookie';import{useMutationWithValidationErrors}from'./useMutationWithValidationErrors';const useOtpRemove=()=>useMutationWithValidationErrors(OTP_REMOVE,data=>undefined,(cache,response)=>{var _response$data,_response$data$otpRem;const token=(_response$data=response.data)===null||_response$data===void 0?void 0:(_response$data$otpRem=_response$data.otpRemove)===null||_response$data$otpRem===void 0?void 0:_response$data$otpRem.token;if(!token)return;const cookies=new Cookies();cookies.set('authToken',token,{path:'/'});// const playlist = response.data?.OtpRemove?.playlist;
// if (!playlist) return;
// const data = cache.readQuery<GetPlaylists>({
//   query: GET_PLAYLISTS
// });
// if (!data) return;
// const newData: GetPlaylists = {
//   playlists: [...data.playlists, playlist]
// };
// cache.writeQuery({
//   query: GET_PLAYLISTS,
//   data: newData
// });
});export default useOtpRemove;